import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./PropertyDevelopment.css";
import kitchen1 from "../../images/gallery/kitchen/kitchen1.png";
import kitchen2 from "../../images/gallery/kitchen/kitchen2.png";
import kitchen3 from "../../images/gallery/kitchen/kitchen3.png";
import kitchen4 from "../../images/gallery/kitchen/kitchen4.png";

import bathroom1 from "../../images/gallery/bathroom/bathroom1png.png";
import bathroom2 from "../../images/gallery/bathroom/bathroom2.png";
import bathroom3 from "../../images/gallery/bathroom/bathroom3.png";
import bathroom4 from "../../images/gallery/bathroom/bathroom4.png";

function PropertyDevelopment() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="property-development">
      <div className="property-development__preview">
        <h1 className="property-development__title">PROPERTY DEVELOPMENT</h1>
        <h2 className="property-development__subtitle">MIKDASH DEVELOPMENT</h2>
      </div>
      <p className="property-development__text">
        We offer comprehensive solutions for the implementation of your
        construction projects in the USA. Whether you are building your dream
        home from scratch or renovating an existing property, we provide a full
        range of development and construction services.
      </p>
      <div className="property-development__photo-container">
        <div className="property-development__card property-card-1">
          <h3 className="property-development__card-title">Planning&Design</h3>
          <p className="property-development__card-text">
            Planning and Design: Our experienced architects and engineers will
            create a project that takes into account all your preferences and
            the features of the site
          </p>
        </div>
        <div className="property-development__card property-card-2">
          <h3 className="property-development__card-title">
            Selection&Supply of Building Materials
          </h3>
          <p className="property-development__card-text">
            We provide high-quality building materials at competitive prices,
            ensuring the durability and reliability of your project
          </p>
        </div>
        <div className="property-development__card property-card-3">
          <h3 className="property-development__card-title">
            Construction Work
          </h3>
          <p className="property-development__card-text">
            Professional builders and contractors from Mikdash Development will
            ensure the quality execution of all construction stages.
          </p>
        </div>
        <div className="property-development__card property-card-4">
          <h3 className="property-development__card-title">
            Interior&Finishing
          </h3>
          <p className="property-development__card-text">
            We offer solutions for interior finishing and furnishing to make
            your house feel like a real home.
          </p>
        </div>
      </div>
      <div className="property-development__gallery">
        <h4 className="property-development__gallery-title">GALLERY</h4>
        <p className="property-development__gallery-text">
          Take a look at our gallery page to see what we offer and how our
          products will look in the interior of your kitchen, bathroom, living
          room of your home
        </p>
        <div className="property-development__gallery-container">
          <img
            className="property-development__img"
            src={kitchen1}
            alt="kitchen"
          />
          <img
            className="property-development__img"
            src={bathroom1}
            alt="bathroom"
          />
          <img
            className="property-development__img"
            src={kitchen2}
            alt="kitchen"
          />
          <img
            className="property-development__img"
            src={bathroom2}
            alt="bathroom"
          />
          <img
            className="property-development__img"
            src={kitchen3}
            alt="kitchen"
          />
          <img
            className="property-development__img"
            src={bathroom3}
            alt="kitchen"
          />
          <img
            className="property-development__img"
            src={kitchen4}
            alt="kitchen"
          />
          <img
            className="property-development__img"
            src={bathroom4}
            alt="bathroom"
          />
        </div>
        <Link to="/gallery" className="property-development__button">
          Go to Gallery
        </Link>
      </div>
    </section>
  );
}

export default PropertyDevelopment;
